<script setup lang="ts">
import FaceBox from "@/components/Common/FaceBox.vue";
import TechnoFrame from "@/components/Common/TechnoFrame.vue";
</script>

<script lang="ts">
import { defineComponent } from 'vue'
import store from "@/store";
import {PassProperties} from "@/components/RegistrationPage/Card/PassProperties";

export default defineComponent({
    name: 'SelectedBonusesDisplay2',

    data() {
        return {
            state: store.state,
        }
    },

    computed: {
        selectedPass(): PassProperties | null
        {
            return this.state.selectedPass
        },

        includedPassesCount(): number
        {
            const selectedPass = this.selectedPass
            if (!selectedPass) {
                return 0
            }

            let count = 0
            this.state.passes.forEach((_, i) => {
                if (i <= (selectedPass.level ?? 0)) {
                    count++
                }
            })

            return count
        },
    },
})
</script>

<template>
    <div
        class="box d-flex flex-column align-items-center justify-content-center"
        v-if="selectedPass"
    >
        <TechnoFrame :offset="8" :size-modifier="0.3"/>

        <p
            class="label"
            :style="{
                borderColor: selectedPass.glowColor,
                // color: selectedPass.glowColor,
                // color: 'white',
                // boxShadow: `0 0 5px 1px ${selectedPass.glowColor}`,
            }"
        >
            <span>Пропуск <b :style="{color: selectedPass.labelColor,}">«{{ selectedPass.name }}»</b> содержит:</span>
        </p>

        <div class="d-flex flex-column gap-4 w-fit-content bg-black">
            <div class="title-container d-flex flex-row gap-4 justify-content-center align-items-center">
                <div class="titleLabel">{{ selectedPass.title }}</div>

                <div class="priceBox d-flex flex-row justify-content-center align-items-center">
                    <img class="icon" :src="`/img/page/landing/registration/icon/galacoin.png`"/>

                    <div class="d-flex flex-column justify-content-center align-items-center text-nowrap">
                        <span class="amount">{{ selectedPass.galacoinAmount.toLocaleString('ru').replace(/\u00A0/g, ' ') }}</span>
                        <span class="currency">галакоинов</span>
                    </div>
                </div>
            </div>

            <div
                class="bonuses d-flex flex-row align-items-center justify-content-center flex-wrap"
                :class="[
                    `count-${includedPassesCount}`,
                    {
                        large: store.state.pageSize.width >= 1600,
                        medium: store.state.pageSize.width >= 1280,
                        small: store.state.pageSize.width < 1280,
                    }
                ]"
            >
                <template
                     v-for="pass in state.passes"
                     :key="pass.code"
                >
                    <div
                        class="bonusBox"
                        v-if="pass.level <= selectedPass.level"
                        :style="{
                            borderColor: pass.glowColor,
                            boxShadow: `0 0 5px 1px ${pass.glowColor}`,
                        }"
                    >
                        <div class="bb-container d-flex flex-column align-items-center justify-content-sm-between">
                            <div
                                class="background"
                                :style="{
                                    backgroundImage: `url('/img/page/landing/registration/cardBg/${pass.background}.webp')`,
                                }"
                            />

                            <span>Все бонусы пропуска <span :style="{color: pass.labelColor}">«{{ pass.name }}»</span></span>

                            <div class="d-flex flex-row align-items-center justify-content-center">
                                <div class="d-flex flex-row align-items-center justify-content-center">
                                    <FaceBox
                                        :size="140"
                                        :face="pass.avatar.image"
                                        :frame="pass.frame.image"
                                    />

                                    <img
                                        class="ship"
                                        :class="{
                                            flipped: pass.code === 'WHITE_PASS'
                                        }"
                                        :src="`/img/page/landing/registration/ship/${pass.ship.image}`"
                                    />
                                </div>
                            </div>

                            <ul>
                                <li
                                    v-for="(bonus, i) in pass.bonuses"
                                    :key="i"
                                    @mouseenter="state.passBonus = bonus"
                                    @mouseleave="state.passBonus = null"
                                >
                                    <template v-if="bonus.image === 'boosts'">
                                        <div class="item lightning">
                                            <svg class="item-icon lightning-icon" viewBox="0 0 24 24">
                                                <path d="M7 2v11h3v9l7-12h-4l4-8z" fill="#fff176"/>
                                            </svg>
                                        </div>
                                    </template>

                                    <template v-else>
                                        <img
                                            class="itemIcon"
                                            :src="`/img/page/landing/registration/item/${bonus.image}.png`"
                                        />
                                    </template>

                                    <span>{{ bonus.name }}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.05s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

.list-move,
.list-enter-active,
.list-leave-active {
    transition: all 0.2s ease;
}

.list-enter-from,
.list-leave-to {
    opacity: 0;
    transform: translateY(50px);
}

.list-leave-active {
    position: absolute;
}

.box {
    max-width: 1600px;
    min-width: 0;
    width: fit-content;
}

p {
    margin: 0;
    text-align: center;
    border-radius: 5px;

    &.label {
        background: rgba(255, 255, 255, 0.1);
        color: white;
        font-size: 18px;
        width: 100%;
        padding: 25px 0 45px 0;
        background-image: v-bind('`url("/img/page/landing/registration/cardBg/${selectedPass.background}.webp")`');
        background-size: cover;
        background-position: center center;
        box-shadow: inset 0 -15px 10px 5px black;

        span {
            display: block;
            width: 100%;
            padding: 5px 0 5px 0;
            background: linear-gradient(90deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.7) 25%, rgba(0,0,0,0.7) 75%, rgba(0,0,0,0) 100%);
        }
    }
}

.row_1 {
    gap: 15px;
}

.title-container {
    padding: 2px 20px 2px 20px;
}

.bonuses {
    padding: 0 30px 40px 30px;
    gap: 15px;
    max-width: 1150px;
}

.bonusBox {
    position: relative;
    border: 1px solid rgba(255, 255, 255, 0.3);
    border-radius: 7px;
    padding: 5px 5px 0 5px;
    overflow: hidden;
    background-size: cover;
    width: 340px;

    div.background {
        position: absolute;
        background-size: cover;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        opacity: 0.5;
        z-index: 0;
    }

    span {
        font-size: 14px;
        color: white;
        z-index: 100;
    }

    .ship {
        width: 120px;
        height: 120px;
        z-index: 100;

        &.flipped { transform: scaleX(-1); }
    }

    .lootBox {
        display: flex;
        flex-direction: row;
        gap: 5px;
        align-items: center;
        justify-items: center;
        border-radius: 5px;
        width: 100%;
        z-index: 100;

        .boxImage {
            width: 130px;
        }
    }

    ul {
        z-index: 100;
        list-style: none;
        width: 100%;
        height: 100px;
        margin: 0;
        display: flex;
        flex-direction: row;
        justify-content: center;
        gap: 6px;
        background: rgba(0, 0, 0, 0.4);
        padding: 5px;

        li {
            width: 130px;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
            gap: 2px;
            font-size: 14px;
            cursor: help;
            padding: 2px 10px 2px 10px;
            text-align: center;

            background: rgba(0, 0, 0, 0.3);
            border: 1px solid rgba(255, 255, 255, 0.04);
            border-radius: 4px;

            &:hover {
                background: rgba(0, 0, 0, 0.5);
            }

            .itemIcon {
                width: 40px;
                height: 40px;
            }

            span {
                text-decoration: underline;
                text-decoration-color: #b0b0b0;
            }

            .lightning {
                width: 40px;
                height: 40px;
            }

            .lightning-icon {
                animation: lightning-pulse 3s ease-in-out infinite;
            }

            .lightning-icon path {
                animation: lightning-color 3s ease-in-out infinite;
            }
        }
    }
}


.titleLabel {
    width: fit-content;
    background: #5d3e04;
    box-shadow: 0 0 5px 1px orange;
    border: 1px solid orange;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4px 15px 4px 15px;
    margin: 0 4px 0 4px;
    font-size: 18px;
    color: orange;
}

.choiceLabel {
    width: 100%;
    text-align: center;
    font-size: 20px;
    color: rgb(220, 220, 220);
    text-shadow: 2px 2px 5px black;
}

.choiceDescription {
    width: 100%;
    text-align: center;
    font-size: 16px;
    color: rgb(122, 115, 115);

    a {
        color: rgb(194, 192, 192);
        text-decoration: underline;
    }
}

.paymentButton {
    width: 100%;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(0, 128, 0, 0.3);
    color: #00ff00;
    border-radius: 10px;
    box-shadow: 0 0 10px 3px rgba(0, 0, 0, 0.8);
    cursor: pointer;

    &:hover {
        background: rgba(0, 128, 0, 0.4);
    }

    &:active {
        background: rgba(0, 128, 0, 0.5);
    }
}

.wrapper {
    position: relative;
    //background: black;
    //box-shadow: 0 0 15px 3px black;
    width: fit-content;
    margin: 0 auto;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    color: white;
    text-shadow: 2px 2px 5px black;
    background: rgba(0, 0, 0, 0.6);
    //margin-bottom: 100px;
    box-shadow: 0 0 25px 5px black;

    .content {
        position: relative;
        width: fit-content;
        padding: 15px;
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: center;
    }


    span.label {
        margin: 0;
        padding: 0;
        line-height: 1;
        color: #c2c2c2;

        span {
            color: wheat;
        }
    }

    .priceBox {
        gap: 4px;

        .icon {
            width: 40px;
            height: 40px;
        }

        .amount {
            font-size: 30px;
            width: 86px;
            text-align: center;
            color: #a8f5ff;
            line-height: 1;
            text-shadow: 2px 2px 5px black;
        }

        .currency {
            color: #00ffff;
            font-size: 14px;
            line-height: 1;
            text-shadow: 2px 2px 5px black;
        }
    }
}
</style>
